import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import ErrorBoundary from './components/ErrorBoundary';
import LoginPage from './components/LoginPage';
import StartScreen from './components/StartScreen';
import IDCard from './components/IDCard';
import Goodies from './components/Goodies';
import Dashboard from './components/Dashboard';
import Logout from './components/Logout';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <ErrorBoundary>
      <div className="App" >
        <Router>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/start" element={<StartScreen />} />
            <Route path="/idcard/:employeeId" element={<IDCard />} />
            <Route path="/goodies" element={<Goodies />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/logout" element={<Logout />} />
          </Routes>
        </Router>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </ErrorBoundary>
  );
}

export default App;
